import { render, staticRenderFns } from "./registerstudentlinechart.component.vue?vue&type=template&id=1823c922&scoped=true"
import script from "./registerstudentlinechart.component.vue?vue&type=script&lang=js"
export * from "./registerstudentlinechart.component.vue?vue&type=script&lang=js"
import style0 from "./registerstudentlinechart.component.vue?vue&type=style&index=0&id=1823c922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823c922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
